export class ProposalGenerationDto {
   maxLeads: number = 0;
}